import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import orderStatusStyles from './order-status.styles.js';
import { renderOrderContent } from './templates/order-content.js';
import { renderOrderMeta } from './templates/order-meta.js';
import { OrderRequestController } from './order-request-controller.js';
import { OrderDto } from '../../interfaces/index.js';
import { renderLoading } from './templates/render-loading.js';
import { renderError } from './templates/render-error.js';

@customElement('order-status')
export class OrderStatus extends LitElement {
  static styles = orderStatusStyles;

  @property({ type: String, reflect: true })
  set orderCode(value: string) {
    this.requestController.orderCode = value;
  }

  private requestController: OrderRequestController;

  constructor() {
    super();
    this.requestController = new OrderRequestController(this, this.orderCode);
  }

  createRenderRoot() {
    if (this.shadowRoot) {
      this.shadowRoot.innerHTML = '';
      this.shadowRoot.adoptedStyleSheets = [];
    }

    return super.createRenderRoot();
  }

  private getOrderStatus() {
    if (this.requestController.errorType) {
      return this.requestController.errorType;
    }

    return this.requestController.order?.status ?? 'Loading';
  }

  private renderOrder(order: OrderDto) {
    const { status, code, createdAt, updatedAt } = order;
    const date = updatedAt || createdAt;

    return html`
      ${renderOrderMeta(status, code, date)}
      <div id="divider"></div>
      <div id="order-content">${renderOrderContent(order)}</div>
    `;
  }

  render() {
    const status = this.getOrderStatus();
    const order = this.requestController.order;

    return html` <div id="order-container" status=${status}>
      ${this.requestController.render({
        pending: () => renderLoading(),
        complete: () => (order ? this.renderOrder(order) : null),
        error: () => {
          return renderError(this.requestController.errorType!, this.orderCode);
        },
      })}
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'order-status': OrderStatus;
  }
}
